import React from 'react';
import Button from '../common/Button';

function TeamMemberForm({ member, index, onChange, onRemove }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange(index, { ...member, [name]: value });
  };

  return (
    <div className="p-4 border border-gray-200 rounded-lg mb-3 bg-gray-50">
      <div className="flex justify-between items-center mb-3">
        <h4 className="font-medium text-gray-700">Team Member {index + 1}</h4>
        <Button
          variant="danger"
          onClick={() => onRemove(index)}
          className="text-sm"
        >
          Remove
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">
            Name
          </label>
          <input
            type="text"
            name="name"
            value={member.name || ''}
            onChange={handleChange}
            className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">
            Company
          </label>
          <input
            type="text"
            name="company"
            value={member.company || ''}
            onChange={handleChange}
            className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">
            Role
          </label>
          <input
            type="text"
            name="role"
            value={member.role || ''}
            onChange={handleChange}
            className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">
            Phone
          </label>
          <input
            type="tel"
            name="phone"
            value={member.phone || ''}
            onChange={handleChange}
            className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
          />
        </div>

        <div className="md:col-span-2">
          <label className="block text-xs font-medium text-gray-600 mb-1">
            Email
          </label>
          <input
            type="email"
            name="email"
            value={member.email || ''}
            onChange={handleChange}
            className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
          />
        </div>
      </div>
    </div>
  );
}

export default TeamMemberForm;
